import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import moment from 'moment'


const Header = ({classes, record, samples})=>{
    //const record= props.record
    //const classes = props.classes
    const city = record && record.city? record.city : '';
    const state= record && record.state? record.state : '';
    const code=  record && record.code? record.code : '';
    const sub_code=  record && record.sub_code? record.sub_code : '';
    const phone=  record && record.phone? record.phone : '';
    const box_num=  record && record.box_num? record.box_num : '';
    const disp_name=record && record.disp_name? record.disp_name : '';
    const total= samples && samples[0].total? samples[0].total : '';

    const title = (samples && samples[0].test_mode=== 'VMT')? 'PLASMA UNIT SAMPLE SUBMISSION': 
                  (samples && samples[0].test_mode=== 'ATYA')? 'ATYA TESTING PACKING LIST':
                  (samples && samples[0].test_mode=== 'SPE')? 'SPE/STS PACKING LIST/WORKSHEET':
                  (samples && samples[0].test_mode=== 'NAT')? 'NAT SAMPLE SUBMISSION': '';

    return(
        <table className={classes.outerTable}>
            <tbody  >
                <tr>
                    <td style={{verticalAlign: 'top'}}>
                    <table className={classes.tableStyleCenter}>
                        <tbody>
                            <tr>
                                <td colSpan="2" className={classes.title}>{title}</td>
                            </tr>
                            <tr>
                                <td  colSpan="2">
                                    {disp_name}<br/>
                                    Printed On: {moment().format('MMMM Do YYYY')}
                                </td>
                            </tr>
                            <tr>
                                <td>&nbsp;</td>
                            </tr>
                            <tr>
                                <td  colSpan="2" align="left">
                                    Center: {city}, {state} | {code} | {sub_code}
                                </td>
                            </tr>
                            <tr>
                                <td  colSpan="2" align="left">
                                Phone: {phone}
                                </td>
                            </tr>
                            <tr>
                                <td align="left">
                                   {(samples && samples[0].test_mode=== 'NAT')? '' : `Box Number: ${box_num}` }  
                                </td>
                                <td align="right">
                                    {(samples && samples[0].test_mode=== 'NAT')? '' : `Total # of Samples: ${total}` }
                                </td>
                            </tr>
                        </tbody>
                        </table>
                    </td>
                </tr>
            </tbody>
        </table>
        
    )

}

export default Header